import { doIt } from "@/utils/doIt";

//

/**
 * Возвращает слово с правильным окончанием для указанного числа.
 * @param count - Число, для которого подбирается окончание.
 * @param one - Слово в единственном числе (например, "товар").
 * @param two - Слово для чисел 2, 3, 4 (например, "товара").
 * @param five - Слово для чисел 5 и больше (например, "товаров").
 * @returns Слово с правильным окончанием.
 */

export function plural(
  count: number,
  one: string,
  two: string,
  five: string,
  wordSide: "right" | "left" | null = "right",
): string {
  const word = doIt(() => {
    const mod10 = count % 10;
    const mod100 = count % 100;

    if (mod10 === 1 && mod100 !== 11) {
      return one;
    } else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
      return two;
    } else {
      return five;
    }
  });

  if (wordSide === null) return word;
  if (wordSide === "left") return `${word} ${count}`;
  return `${count} ${word}`;
}
